var {AmpersandApp: productCatalogApp, AmpersandView} = require('catalog/libs');

var HPEConstants = require('../../../base/hpe.constants');

var template = require('../templates/hpe.productlist.breadcrumb.template.tpl');

/**
 * collection of breadcrumb filters
 */
var BreadcrumbFilterCollectionView = AmpersandView.extend({

    render: function(opts) {
        this.renderCollection(this.collection, function(options) {
            return new BreadcrumbFilterView(options);
        }, this.el, opts);
        return this;
    }
});

/**
 * individual breadcrumb filter view
 */
var BreadcrumbFilterView = AmpersandView.extend({

    template: template,
    bindings: {
        'model.labelValue': {
            type: 'innerHTML',
            selector: 'span'
        },
        'model.analyticsEvent': {
            type: 'attribute',
            selector: 'button',
            name: 'data-analytics-event'
        }
    },

    events: {
        'click button': 'onBreadcrumbFilterClick'
    },

    /**
     * handle checkbox input change event
     */
    onBreadcrumbFilterClick: function() {

        //remove all filters in facet or just a specific filter within the facet
        var type = (this.model.id === this.model.parentId) ? 'facetremove' : 'filterremove';

        //broadcast view update request
        productCatalogApp.trigger(HPEConstants.catalog.VIEW_UPDATE_REQUEST, {
            id: this.model.parentId,
            value: this.model.facetValueId,
            type: type
        });
    }
});

/**
 * overall breadcrumb view
 */
var BreadcrumbView = AmpersandView.extend({

    template: function() {
        var breadcrumbTemplate = '<div class="filter-breadcrumbs" data-hook="filter-breadcrumbs"><h1 class="filter-trail"><span class="filter-trail-copy"></span><span class="filter-trail-cta"><ul></ul></span></h1></div>';

        //template differs slightly between listing (h1) and detail page (div)
        if (productCatalogApp.isTabInstance) {
            breadcrumbTemplate = breadcrumbTemplate.replace(/h1/g, 'div');
        }
        return breadcrumbTemplate;
    },

    bindings: {
        'model.pageLabel': {
            type: 'text',
            selector: '.filter-trail-copy'
        }
    },

    subviews: {
        items: {
            selector: 'ul',
            waitFor: 'model.items',
            prepareView: function(el) {
                return new BreadcrumbFilterCollectionView({
                    el: el,
                    collection: this.model.items
                });
            }
        }
    }
});

module.exports = BreadcrumbView;
